module.exports = __webpack_public_path__ + "static/media/repair-shop.b2d77752.png";